import { FlaskConical, BarChart3, GitCompare, CheckCircle } from "lucide-react";

export default function ValidationSection() {
  const validations = [
    {
      icon: BarChart3,
      text: "Simulações multi-anuais (6 anos de dados operacionais)",
    },
    {
      icon: GitCompare,
      text: "Cenários com múltiplos ciclos estratégicos completos",
    },
    {
      icon: CheckCircle,
      text: "Testes de coerência matemática e consistência narrativa",
    },
    {
      icon: FlaskConical,
      text: "Comparação metodológica com estruturas de análise de dinâmica operacional utilizadas em ambientes corporativos avançados",
    },
  ];

  return (
    <section
      id="validation"
      className="relative py-16 md:py-32 bg-[#0A0B0E]"
      data-testid="validation-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Validação
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Validação <span className="text-[#F59E0B]">Estrutural</span>
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-[#9CA3AF] text-base md:text-lg mb-2">
              O KpAction não nasceu de opinião.
            </p>
            <p className="text-[#E5E7EB] text-base md:text-lg font-medium">
              Foi estruturado e testado com base em:
            </p>
          </div>

          {/* Validation Points */}
          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10 mb-12">
            <div className="space-y-6">
              {validations.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 pb-6 border-b border-[#2A2F38] last:border-0 last:pb-0"
                  data-testid={`validation-item-${index}`}
                >
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                    <item.icon className="h-5 w-5 text-[#F59E0B]" />
                  </div>
                  <p className="text-[#E5E7EB] pt-2">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom Statement */}
          <div className="text-center">
            <p className="text-[#9CA3AF] text-base md:text-lg mb-2">
              Não é uma hipótese.
            </p>
            <p className="text-[#F59E0B] text-lg md:text-xl font-medium">
              É uma estrutura validada.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
